import styles from './index.less';
import classNames from 'classnames';
import LatestRecommendations from '@/pages/personalService/components/latestRecommendations';
import React, { useEffect, useState } from 'react';
import DetailedRecommendation from '@/pages/personalService/components/detailedRecommendation';
import { ComponentWrapper } from '@digit-fe/digit-component';
import '@/utils/advertisementSDK.js';
import BBSCard from './components/bbsCard';

const HOME_TOP_AD_ID = '0006c10661d34e02b6dae3945e72c7ae';

export default function IndexPage() {
  const [isWelComeFinished, setIsWelComeFinished] = useState(false);
  const [isHomeTopAdVisible, setIsHomeTopAdVisible] = useState(false);

  useEffect(() => {
    let isMounted = true;

    const loadHomeTopAd = async () => {
      const getAdEnv = process.env.UMI_ENV == 'product' ? false : true;
      window.fineAd.config({ debug: getAdEnv, dev: getAdEnv });
      await window.fineAd.getAdvertisement({
        adId: HOME_TOP_AD_ID,
      });
      const adNode = document.getElementById(`AD-${HOME_TOP_AD_ID}`);
      if (isMounted) {
        setIsHomeTopAdVisible(Boolean(adNode?.innerHTML));
      }
    };

    loadHomeTopAd();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      <div
        className={styles.home_top_ad_wrapper}
        style={{ display: isHomeTopAdVisible ? 'block' : 'none' }}
      >
        <div id={`AD-${HOME_TOP_AD_ID}`} className={styles.home_top_ad}></div>
      </div>
      <div className={classNames(styles.layout_base_flex)}>
        <LatestRecommendations isWelComeFinished={isWelComeFinished} />
        <div className={classNames(styles.layout_vertical)}>
          <ComponentWrapper>
            <>
              <img
                style={{
                  width: '384px',
                  borderRadius: '12px',
                  marginBottom: '24px',
                  cursor: 'pointer',
                }}
                src={require('@/static/images/home_pic.png')}
                onClick={() => {
                  window.open('https://edu.fanruan.com/studypath/finebi');
                }}
              />
              <BBSCard />
              <DetailedRecommendation />
            </>
          </ComponentWrapper>
        </div>
      </div>
    </>
  );
}
